import { useEffect, useState } from 'react';
import { ImEye, ImEyeBlocked } from "react-icons/im";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import Select, { components } from 'react-select';
import Swal from 'sweetalert2';
import Footer from '../../Components-2/Footer';
import Header from '../../Components-2/Header/Header';
import Sidebar1 from '../../Components-2/Sidebar1';
import { getApi, postApi } from '../Admin Master/Area Control/Zonemaster/ServicesApi';
function UserAdmin() {
    const [openRow, setOpenRow] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [eye, setEye] = useState(true);
    const [eyeDis, setEyeDis] = useState(false);
    const [getData, setGetData] = useState([]);
    const [getEmployee, setGetEmployee] = useState([]);
    const [getCustomerdata, setgetCustomerdata] = useState([]);
    const [getBranch, setGetBranch] = useState([]);
    const [selectedOption, setSelectedOption] = useState("");
    const [selectedOperation, setSelectedOperation] = useState("");
    const [formData, setFormData] = useState({
        ID: "",
        UserName: "",
        Employee_Code: "",
        Customer_Code: "",
        Password: "",
        City_Code: "",
        UserType: "User",
        RateType: [],
        DocketBooking: 0,
        CoshTopayBooking: 0,
        Smartbooking: 0,
        DashboardAccess: 0,
        TrackingEntry: 0,
        BulkTrackingUpload: 0,
        BankImport: 0,
        BulkImportFile: 0,
        PerformaInvoice: 0,
        ForwardingInternational: 0,
        RateCalculator: 0,
        AutoMail: 0,
        BulkImportData: 0,
        VendorBillEntry: 0,
        PendingManifest: 0,
        OutgoingManifest: 0,
        ViewManifest: 0,
        BuilkimportManifest: 0,
        InternationalManifest: 0,
        PendingScan: 0,
        InscanbyDRSNo: 0,
        ScanbyDocketNo: 0,
        InscanProcessView: 0,
        DeliveryPending: 0,
        DeliveryBooking: 0,
        DrsView: 0,
        Drsimport: 0,
        Statusactivity: 0,
        StatusactivityimportBulk: 0,
        StatusactivityTracking: 0,
        DeliveryEntry: 0,
        ReturnEntry: 0,
        BulkUploadExcel: 0,
        DocketPrint1: 0,
        Docketprint2: 0,
        Docketprint3: 0,
        Docketprint4: 0,
        LebelPrintin: 0,
        DocketPrint: 0,
        StickerPrinting: 0,
        InternationalBooking: 0,
        ComplaintRegister: 0,
        ViewComplaintStatus: 0,
        ComplaintQuery: 0,
        PendingInvoice: 0,
        GenerateInvoice: 0,
        ViewInvoice: 0,
        InvoiceSummary: 0,
        Docket_Print: 0,
        PerformanceInvoice: 0,
        ViewPerformanceInvoice: 0,
        PaymentReceivedEntry: 0,
        PayOutStanding: 0,
        CreditBooking: 0,
        CreditNoteView: 0,
        MISReport: 0,
        VendorMISReport: 0,
        BookingModeReport: 0,
        BookingDetail: 0,
        TotalChargesReport: 0,
        ModeWiseReport: 0,
        InvoiceLedgerReport: 0,
        ChecklistReport: 0,
        UnbuildReport: 0,
        BillViewReport: 0,
    });

    const bookingModes = [
        { value: "Cash", label: "Cash" },
        { value: "Credit", label: "Credit" },
        { value: "To-pay", label: "To-pay" },
        { value: "Google Pay", label: "Google Pay" },
        { value: "RTGS", label: "RTGS" },
        { value: "NEFT", label: "NEFT" }
    ];

    const togglePass = () => {
        setEye((eye) => !eye);
    }
    useEffect(() => {
        console.log(formData);
    }, [formData])
    useEffect(() => {
        if (!formData.Password) {
            setEyeDis(true);
        }
        else {
            setEyeDis(false);
        }
    }, [formData.Password])
    const fetchBranchData = async () => {
        try {
            const response = await getApi(
                `/Master/GetAllBranchData?Branch_Code=${JSON.parse(localStorage.getItem('Login'))?.Branch_Code}`
            );

            let data = Array.isArray(response.Data) ? response.Data : [];

            // ✅ REMOVE ALB
            const filteredData = data.filter(
                (item) => item.Branch_Code !== 'ALB'
            );

            setGetBranch(filteredData);

        } catch (err) {
            console.error('Fetch Error:', err);
        }
    };

    const fetchEmpData = async () => {
        try {
            const response = await getApi(`/Master/GetEmployee?Branch_Code=${formData.City_Code}`);
            setGetEmployee(Array.isArray(response.Data) ? response.Data : []);
        } catch (err) {
            console.error('Fetch Error:', err);
        }
    };
    const fetchCusData = async () => {
        try {

            const response = await getApi(`/Master/getCustomerdata?Branch_Code=${formData.City_Code}`)
            setgetCustomerdata(Array.isArray(response.Data) ? response.Data : []);
        } catch (err) {
            console.error('Fetch Error:', err);
        }
    };
    const fechUserData = async () => {
        try {
            const response = await getApi(`/Master/GetOperationManagement?Branch_Code=${JSON.parse(localStorage.getItem('Login'))?.Branch_Code}&UserType=User`);
            setGetData(Array.isArray(response.data) ? response.data : []);
        } catch (err) {
            console.error('Fetch Error:', err);
        }
    };

    useEffect(() => {
        fetchEmpData();
        fetchCusData();
        fetchBranchData();
        fechUserData();
    }, []);

    useEffect(() => {
        if (formData.City_Code) {
            fetchEmpData();
            fetchCusData();
        }

    }, [formData.City_Code]);


    const allCustomerOptions =

        Array.isArray(getCustomerdata) && getCustomerdata.length > 0
            ? getCustomerdata
                .map(cust => ({
                    label: cust.Customer_Name,
                    value: cust.Customer_Code.toString(),
                    Booking_Type: cust.Booking_Type,
                    CustomerGst: cust.CustomerGst,
                    CustomerFuel: cust.CustomerFuel,
                    Branch_Code: cust.Branch_Code,
                    City_Code: cust.City_Code,
                }))
            : []

    const handleDelete = async (ID) => {
        const confirmDelete = await Swal.fire({
            title: 'Are you sure?',
            text: 'Do you really want to delete this zone?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
        });

        if (confirmDelete.isConfirmed) {
            try {
                await postApi(`/Master/DeleteOperationManagement?ID=${ID}`);
                setGetData(getData.filter((data) => data.ID !== ID));
                Swal.fire('Deleted!', 'The User has been deleted.', 'success');
                ResetAll(null)
                await fechUserData();
            } catch (err) {
                console.error('Delete Error:', err);
                Swal.fire('Error', 'Failed to delete User Admin', 'error');
            }
        }
    };

    const handleRadioChange = (value) => {
        setSelectedOption((prev) => (prev === value ? "" : value));
    };

    const handleCheckboxChange = (value) => {
        setSelectedOperation((prev) =>
            prev.includes(value)
                ? prev.filter((item) => item !== value)
                : [...prev, value]
        );
    };

    const handleCheckboxselected = (e) => {
        const { name, checked } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: checked,
        }));
    };
    const ResetAll = (e) => {
        e.preventDefault();
        setEditMode(false);
        setFormData({
            ID: "",
            UserName: "",
            Employee_Code: "",
            Customer_Code: "",
            Password: "",
            City_Code: "",
            UserType: "User",
            RateType: [],
            DocketBooking: 0,
            CoshTopayBooking: 0,
            Smartbooking: 0,
            DashboardAccess: 0,
            TrackingEntry: 0,
            BulkTrackingUpload: 0,
            BankImport: 0,
            BulkImportFile: 0,
            PerformaInvoice: 0,
            ForwardingInternational: 0,
            RateCalculator: 0,
            AutoMail: 0,
            BulkImportData: 0,
            VendorBillEntry: 0,
            PendingManifest: 0,
            OutgoingManifest: 0,
            ViewManifest: 0,
            BuilkimportManifest: 0,
            InternationalManifest: 0,
            PendingScan: 0,
            InscanbyDRSNo: 0,
            ScanbyDocketNo: 0,
            InscanProcessView: 0,
            DeliveryPending: 0,
            DeliveryBooking: 0,
            DrsView: 0,
            Drsimport: 0,
            Statusactivity: 0,
            StatusactivityimportBulk: 0,
            StatusactivityTracking: 0,
            DeliveryEntry: 0,
            ReturnEntry: 0,
            BulkUploadExcel: 0,
            DocketPrint1: 0,
            Docketprint2: 0,
            Docketprint3: 0,
            Docketprint4: 0,
            LebelPrintin: 0,
            DocketPrint: 0,
            StickerPrinting: 0,
            InternationalBooking: 0,
            ComplaintRegister: 0,
            ViewComplaintStatus: 0,
            ComplaintQuery: 0,
            PendingInvoice: 0,
            GenerateInvoice: 0,
            ViewInvoice: 0,
            InvoiceSummary: 0,
            Docket_Print: 0,
            PerformanceInvoice: 0,
            ViewPerformanceInvoice: 0,
            PaymentReceivedEntry: 0,
            PayOutStanding: 0,
            CreditBooking: 0,
            CreditNoteView: 0,
            MISReport: 0,
            VendorMISReport: 0,
            BookingModeReport: 0,
            BookingDetail: 0,
            TotalChargesReport: 0,
            ModeWiseReport: 0,
            InvoiceLedgerReport: 0,
            ChecklistReport: 0,
            UnbuildReport: 0,
            BillViewReport: 0,
        });
        setSelectedOperation('');
        setSelectedOption('');
    }
    const handlesave = async (e) => {
        e.preventDefault();
        const errors = [];
        if (!formData.City_Code) errors.push("Branch Name is required");
        if (!formData.UserName) errors.push("User Name is required");
        if (!formData.Password) errors.push("Password is required");
        if (!!formData.Employee_Code === !!formData.Customer_Code) errors.push("Please choose either Employee or Customer, not both.");
        if (errors.length > 0) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                html: errors.map(err => `<div>${err}</div>`).join(''),
            });
            return;
        }

        const requestBody = {
            UserName: formData.UserName || "",
            Employee_Code: formData.Employee_Code || "",
            Customer_Code: formData.Customer_Code || "",
            Password: formData.Password || "",
            City_Code: formData.City_Code || "",
            UserType: formData.UserType || "",
            RateType: formData.RateType.length > 0 ? JSON.stringify(formData.RateType) : "",
            DocketBooking: formData.DocketBooking ? 1 : 0,
            CoshTopayBooking: formData.CoshTopayBooking ? 1 : 0,
            Smartbooking: formData.Smartbooking ? 1 : 0,
            DashboardAccess: formData.DashboardAccess ? 1 : 0,
            TrackingEntry: formData.TrackingEntry ? 1 : 0,
            BulkTrackingUpload: formData.BulkTrackingUpload ? 1 : 0,
            BankImport: formData.BankImport ? 1 : 0,
            BulkImportFile: formData.BulkImportFile ? 1 : 0,
            AutoMail: formData.AutoMail ? 1 : 0,
            BulkImportData: formData.BulkImportData ? 1 : 0,
            VendorBillEntry: formData.VendorBillEntry ? 1 : 0,
            PerformaInvoice: formData.PerformaInvoice ? 1 : 0,
            ForwardingInternational: formData.ForwardingInternational ? 1 : 0,
            RateCalculator: formData.RateCalculator ? 1 : 0,
            PendingManifest: formData.PendingManifest ? 1 : 0,
            OutgoingManifest: formData.OutgoingManifest ? 1 : 0,
            InternationalManifest: formData.InternationalManifest ? 1 : 0,
            ViewManifest: formData.ViewManifest ? 1 : 0,
            BuilkimportManifest: formData.BuilkimportManifest ? 1 : 0,
            PendingScan: formData.PendingScan ? 1 : 0,
            InscanbyDRSNo: formData.InscanbyDRSNo ? 1 : 0,
            ScanbyDocketNo: formData.ScanbyDocketNo ? 1 : 0,
            InscanProcessView: formData.InscanProcessView ? 1 : 0,
            DeliveryPending: formData.DeliveryPending ? 1 : 0,
            DeliveryBooking: formData.DeliveryBooking ? 1 : 0,
            DrsView: formData.DrsView ? 1 : 0,
            Drsimport: formData.Drsimport ? 1 : 0,
            Statusactivity: formData.Statusactivity ? 1 : 0,
            StatusactivityimportBulk: formData.StatusactivityimportBulk ? 1 : 0,
            StatusactivityTracking: formData.StatusactivityTracking ? 1 : 0,
            DeliveryEntry: formData.DeliveryEntry ? 1 : 0,
            ReturnEntry: formData.ReturnEntry ? 1 : 0,
            BulkUploadExcel: formData.BulkUploadExcel ? 1 : 0,
            DocketPrint1: formData.DocketPrint1 ? 1 : 0,
            Docketprint2: formData.Docketprint2 ? 1 : 0,
            Docketprint3: formData.Docketprint3 ? 1 : 0,
            Docketprint4: formData.Docketprint4 ? 1 : 0,
            LebelPrintin: formData.LebelPrintin ? 1 : 0,
            DocketPrint: formData.DocketPrint ? 1 : 0,
            StickerPrinting: formData.StickerPrinting ? 1 : 0,
            InternationalBooking: formData.InternationalBooking ? 1 : 0,
            ComplaintRegister: formData.ComplaintRegister ? 1 : 0,
            ViewComplaintStatus: formData.ViewComplaintStatus ? 1 : 0,
            ComplaintQuery: formData.ComplaintQuery ? 1 : 0,
            PendingInvoice: formData.PendingInvoice ? 1 : 0,
            GenerateInvoice: formData.GenerateInvoice ? 1 : 0,
            ViewInvoice: formData.ViewInvoice ? 1 : 0,
            InvoiceSummary: formData.InvoiceSummary ? 1 : 0,
            Docket_Print: formData.Docket_Print ? 1 : 0,
            PerformanceInvoice: formData.PerformanceInvoice ? 1 : 0,
            ViewPerformanceInvoice: formData.ViewPerformanceInvoice ? 1 : 0,
            PaymentReceivedEntry: formData.PaymentReceivedEntry ? 1 : 0,
            PayOutStanding: formData.PayOutStanding ? 1 : 0,
            CreditBooking: formData.CreditBooking ? 1 : 0,
            CreditNoteView: formData.CreditNoteView ? 1 : 0,
            MISReport: formData.MISReport ? 1 : 0,
            VendorMISReport: formData.VendorMISReport ? 1 : 0,
            BookingModeReport: formData.BookingModeReport ? 1 : 0,
            BookingDetail: formData.BookingDetail ? 1 : 0,
            TotalChargesReport: formData.TotalChargesReport ? 1 : 0,
            ModeWiseReport: formData.ModeWiseReport ? 1 : 0,
            InvoiceLedgerReport: formData.InvoiceLedgerReport ? 1 : 0,
            ChecklistReport: formData.ChecklistReport ? 1 : 0,
            UnbuildReport: formData.UnbuildReport ? 1 : 0,
            BillViewReport: formData.BillViewReport ? 1 : 0,
        };
        try {
            const response = await postApi('/Master/addOperationManagement', requestBody, 'POST');
            if (response.status === 1) {
                setGetData([...getData, response?.data]);
                ResetAll(e);
                Swal.fire('Saved!', response.message || 'Your changes have been saved.', 'success');
                await fechUserData();
            }
        } catch (error) {
            console.error('Unable to add Admin:', error);
        }
    }
    const handleUpdate = async (e) => {
        e.preventDefault();
        const errors = [];
        if (!formData.City_Code) errors.push("Branch Name is required");
        if (!formData.UserName) errors.push("User Name is required");
        if (!formData.Password) errors.push("Password is required");
        if (!!formData.Employee_Code === !!formData.Customer_Code) errors.push("Please choose either Employee or Customer, not both.");
        if (errors.length > 0) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                html: errors.map(err => `<div>${err}</div>`).join(''),
            });
            return;
        }
        const requestBody = {
            ID: formData.ID,
            UserName: formData.UserName || "",
            Employee_Code: formData.Employee_Code || "",
            Customer_Code: formData.Customer_Code || "",
            Password: formData.Password || "",
            City_Code: formData.City_Code || "",
            UserType: formData.UserType || "",
            RateType: formData.RateType.length > 0 ? JSON.stringify(formData.RateType) : "",
            DocketBooking: formData.DocketBooking ? 1 : 0,
            CoshTopayBooking: formData.CoshTopayBooking ? 1 : 0,
            Smartbooking: formData.Smartbooking ? 1 : 0,
            DashboardAccess: formData.DashboardAccess ? 1 : 0,
            TrackingEntry: formData.TrackingEntry ? 1 : 0,
            BulkTrackingUpload: formData.BulkTrackingUpload ? 1 : 0,
            BankImport: formData.BankImport ? 1 : 0,
            BulkImportFile: formData.BulkImportFile ? 1 : 0,
            AutoMail: formData.AutoMail ? 1 : 0,
            BulkImportData: formData.BulkImportData ? 1 : 0,
            VendorBillEntry: formData.VendorBillEntry ? 1 : 0,
            PerformaInvoice: formData.PerformaInvoice ? 1 : 0,
            ForwardingInternational: formData.ForwardingInternational ? 1 : 0,
            RateCalculator: formData.RateCalculator ? 1 : 0,
            PendingManifest: formData.PendingManifest ? 1 : 0,
            OutgoingManifest: formData.OutgoingManifest ? 1 : 0,
            InternationalManifest: formData.InternationalManifest ? 1 : 0,
            ViewManifest: formData.ViewManifest ? 1 : 0,
            BuilkimportManifest: formData.BuilkimportManifest ? 1 : 0,
            PendingScan: formData.PendingScan ? 1 : 0,
            InscanbyDRSNo: formData.InscanbyDRSNo ? 1 : 0,
            ScanbyDocketNo: formData.ScanbyDocketNo ? 1 : 0,
            InscanProcessView: formData.InscanProcessView ? 1 : 0,
            DeliveryPending: formData.DeliveryPending ? 1 : 0,
            DeliveryBooking: formData.DeliveryBooking ? 1 : 0,
            DrsView: formData.DrsView ? 1 : 0,
            Drsimport: formData.Drsimport ? 1 : 0,
            Statusactivity: formData.Statusactivity ? 1 : 0,
            StatusactivityimportBulk: formData.StatusactivityimportBulk ? 1 : 0,
            StatusactivityTracking: formData.StatusactivityTracking ? 1 : 0,
            DeliveryEntry: formData.DeliveryEntry ? 1 : 0,
            ReturnEntry: formData.ReturnEntry ? 1 : 0,
            BulkUploadExcel: formData.BulkUploadExcel ? 1 : 0,
            DocketPrint1: formData.DocketPrint1 ? 1 : 0,
            Docketprint2: formData.Docketprint2 ? 1 : 0,
            Docketprint3: formData.Docketprint3 ? 1 : 0,
            Docketprint4: formData.Docketprint4 ? 1 : 0,
            LebelPrintin: formData.LebelPrintin ? 1 : 0,
            DocketPrint: formData.DocketPrint ? 1 : 0,
            StickerPrinting: formData.StickerPrinting ? 1 : 0,
            InternationalBooking: formData.InternationalBooking ? 1 : 0,
            ComplaintRegister: formData.ComplaintRegister ? 1 : 0,
            ViewComplaintStatus: formData.ViewComplaintStatus ? 1 : 0,
            ComplaintQuery: formData.ComplaintQuery ? 1 : 0,
            PendingInvoice: formData.PendingInvoice ? 1 : 0,
            GenerateInvoice: formData.GenerateInvoice ? 1 : 0,
            ViewInvoice: formData.ViewInvoice ? 1 : 0,
            InvoiceSummary: formData.InvoiceSummary ? 1 : 0,
            Docket_Print: formData.Docket_Print ? 1 : 0,
            PerformanceInvoice: formData.PerformanceInvoice ? 1 : 0,
            ViewPerformanceInvoice: formData.ViewPerformanceInvoice ? 1 : 0,
            PaymentReceivedEntry: formData.PaymentReceivedEntry ? 1 : 0,
            PayOutStanding: formData.PayOutStanding ? 1 : 0,
            CreditBooking: formData.CreditBooking ? 1 : 0,
            CreditNoteView: formData.CreditNoteView ? 1 : 0,
            MISReport: formData.MISReport ? 1 : 0,
            VendorMISReport: formData.VendorMISReport ? 1 : 0,
            BookingModeReport: formData.BookingModeReport ? 1 : 0,
            BookingDetail: formData.BookingDetail ? 1 : 0,
            TotalChargesReport: formData.TotalChargesReport ? 1 : 0,
            ModeWiseReport: formData.ModeWiseReport ? 1 : 0,
            InvoiceLedgerReport: formData.InvoiceLedgerReport ? 1 : 0,
            ChecklistReport: formData.ChecklistReport ? 1 : 0,
            UnbuildReport: formData.UnbuildReport ? 1 : 0,
            BillViewReport: formData.BillViewReport ? 1 : 0,
        };


        try {
            const response = await postApi('/Master/UpdateOperationManagement', requestBody, 'PUT');
            if (response.status === 1) {
                ResetAll(e);
                Swal.fire('Saved!', response.message || 'Your changes have been Updated.', 'success');
                await fechUserData();
            }
        } catch (error) {
            console.error('Unable to add Admin:', error);
        }
    }
    return (
        <>
            <style>{`
.form-check {
    display: flex;
    align-items: center;
    gap: 10px;
}
`}</style>
            <Header />
            <Sidebar1 />

            <div id="main-body">
                <div className="container1">
                    <form action="" onSubmit={handlesave} style={{ background: "white", whiteSpace: "nowrap" }}>
                        <div className="fields2">
                            <div className="input-field1">
                                <label htmlFor="">User Name</label>
                                <input type="text" placeholder='UserName' value={formData.UserName}
                                    onChange={(e) => setFormData({ ...formData, UserName: e.target.value })} />
                            </div>

                            <div className="input-field1">
                                <label htmlFor="">Password</label>
                                <div style={{ position: "relative" }}>
                                    <input type={eye ? "password" : "text"} placeholder='Password' value={formData.Password}
                                        onChange={(e) => setFormData({ ...formData, Password: e.target.value })} />
                                    <div style={{
                                        opacity: eyeDis ? 0 : 1, // fade instead of display: none
                                        visibility: eyeDis ? "hidden" : "visible", //
                                        position: "absolute",
                                        right: "10px",
                                        bottom: "5px",
                                        fontSize: "20px",
                                        cursor: "pointer",
                                        transition: "opacity 0.3s ease, visibility 0.3s ease"
                                    }} onClick={togglePass}>

                                        {eye ? <ImEye /> : <ImEyeBlocked />}
                                    </div>
                                </div>
                            </div>

                            <div className="input-field1">
                                <label htmlFor="">Branch Name</label>
                                <Select
                                    options={getBranch.map(br => ({
                                        value: br.Branch_Code,   // adjust keys from your API
                                        label: br.Branch_Name
                                    }))}
                                    value={
                                        formData.City_Code
                                            ? { value: formData.City_Code, label: getBranch.find(br => br.Branch_Code === formData.City_Code)?.Branch_Name || "" }
                                            : null
                                    }
                                    onChange={(selectedOption) =>
                                        setFormData({
                                            ...formData,
                                            Employee_Code: "",
                                            Customer_Code: "",
                                            City_Code: selectedOption ? selectedOption.value : ""
                                        })
                                    }
                                    placeholder="Select Branch"
                                    isSearchable
                                    classNamePrefix="blue-selectbooking"
                                    className="blue-selectbooking"
                                    menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                                    styles={{
                                        placeholder: (base) => ({
                                            ...base,
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        }),
                                        menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                    }}
                                />

                            </div>

                            <div className="input-field1">
                                <label htmlFor="">Custometr Name</label>
                                <Select
                                    className="blue-selectbooking"
                                    classNamePrefix="blue-selectbooking"
                                    options={allCustomerOptions}
                                    value={
                                        formData.Customer_Code ?
                                            {
                                                value: formData.Customer_Code,
                                                label: allCustomerOptions.find(opt => opt.value === formData.Customer_Code)?.label
                                            } || ""
                                            : null
                                    }
                                    onChange={(selectedOption) => {
                                        setFormData(prev => ({
                                            ...prev,
                                            Customer_Code: selectedOption.value,
                                            Customer_Name: selectedOption.label,

                                        }));
                                    }}
                                    placeholder="Select Customer"
                                    isSearchable
                                    menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll area
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps it above other UI
                                    }}
                                />

                            </div>

                            <div className="input-field1">
                                <label htmlFor="">Employee Name</label>
                                <Select
                                    options={getEmployee.map(emp => ({
                                        value: emp.Employee_Code,   // adjust keys from your API
                                        label: emp.Employee_Name
                                    }))}
                                    value={
                                        formData.Employee_Code
                                            ? { value: formData.Employee_Code, label: getEmployee.find(c => c.Employee_Code === formData.Employee_Code)?.Employee_Name || "" }
                                            : null
                                    }
                                    onChange={(selectedOption) =>
                                        setFormData({
                                            ...formData,
                                            Employee_Code: selectedOption ? selectedOption.value : ""
                                        })
                                    }
                                    placeholder="Select Employee"
                                    isSearchable
                                    classNamePrefix="blue-selectbooking"
                                    className="blue-selectbooking"
                                    menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                                    styles={{
                                        placeholder: (base) => ({
                                            ...base,
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        }),
                                        menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                    }}
                                />

                            </div>
                            <div className="input-field1" style={{ whiteSpace: "nowrap" }}>
                                <label htmlFor="">Rate On / Off</label>
                                <Select
                                    options={bookingModes}

                                    value={
                                        bookingModes.filter(opt =>
                                            formData.RateType?.includes(opt.value)
                                        )
                                    }

                                    onChange={(selectedOptions) =>
                                        setFormData({
                                            ...formData,
                                            RateType: selectedOptions
                                                ? selectedOptions.map(opt => opt.value)
                                                : []
                                        })
                                    }

                                    placeholder="Select Rate on / off"
                                    isSearchable
                                    isMulti
                                    closeMenuOnSelect={false}
                                    hideSelectedOptions={false}

                                    components={{
                                        Option: (props) => (
                                            <components.Option {...props}>
                                                <input
                                                    type="checkbox"
                                                    checked={props.isSelected}
                                                    onChange={() => null}
                                                    style={{ marginRight: "8px" }}
                                                />
                                                <label>{props.label}</label>
                                            </components.Option>
                                        )
                                    }}

                                    classNamePrefix="blue-selectbooking"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            minHeight: "38px",
                                            overflow: "hidden",
                                        }),

                                        valueContainer: (base) => ({
                                            ...base,
                                            flexWrap: "nowrap",   // 👈 important (prevents line wrap)
                                            overflowX: "auto",    // 👈 scroll instead of breaking layout
                                        }),

                                        multiValue: (base) => ({
                                            ...base,
                                            flexShrink: 0,        // 👈 keeps chips intact
                                            whiteSpace: "nowrap",
                                        }),

                                        multiValueLabel: (base) => ({
                                            ...base,
                                            whiteSpace: "nowrap",
                                        }),

                                        multiValueRemove: (base) => ({
                                            ...base,
                                            cursor: "pointer",
                                        }),

                                        option: (base) => ({
                                            ...base,
                                            whiteSpace: "nowrap",
                                        }),
                                    }}
                                />

                            </div>

                            <div className="production-header container-fluid py-2 mx-3 my-3">
                                <div className="production-radio row g-2">
                                    {/* Operation */}
                                    <div className="col-6 col-sm-4 col-md-3 col-lg-2 d-flex align-items-center">
                                        <input
                                            type="radio"
                                            id="operation"
                                            name="section"
                                            value="Operation"
                                            checked={selectedOption === "Dashboard"}
                                            onChange={() => handleRadioChange("Dashboard")}
                                            className="me-2"
                                        />
                                        <label htmlFor="operation" className="mb-0">Dashboard</label>
                                    </div>
                                    {/* Operation */}
                                    <div className="col-6 col-sm-4 col-md-3 col-lg-2 d-flex align-items-center">
                                        <input
                                            type="radio"
                                            id="operation"
                                            name="section"
                                            value="Operation"
                                            checked={selectedOption === "Operation"}
                                            onChange={() => handleRadioChange("Operation")}
                                            className="me-2"
                                        />
                                        <label htmlFor="operation" className="mb-0">Operation</label>
                                    </div>

                                    {/* Customer Complaint */}
                                    <div className="col-6 col-sm-4 col-md-3 col-lg-2 d-flex align-items-center">
                                        <input
                                            type="radio"
                                            id="crm"
                                            name="section"
                                            value="CRM"
                                            checked={selectedOption === "CRM"}
                                            onChange={() => handleRadioChange("CRM")}
                                            className="me-2"
                                        />
                                        <label htmlFor="crm" className="mb-0">Complaint</label>
                                    </div>

                                    {/* Billings */}
                                    <div className="col-6 col-sm-4 col-md-3 col-lg-2 d-flex align-items-center">
                                        <input
                                            type="radio"
                                            id="billings"
                                            name="section"
                                            value="Billings"
                                            checked={selectedOption === "Billings"}
                                            onChange={() => handleRadioChange("Billings")}
                                            className="me-2"
                                        />
                                        <label htmlFor="billings" className="mb-0">Billings</label>
                                    </div>

                                    {/* Payments */}
                                    <div className="col-6 col-sm-4 col-md-3 col-lg-2 d-flex align-items-center">
                                        <input
                                            type="radio"
                                            id="payments"
                                            name="section"
                                            value="Payments"
                                            checked={selectedOption === "Payments"}
                                            onChange={() => handleRadioChange("Payments")}
                                            className="me-2"
                                        />
                                        <label htmlFor="payments" className="mb-0">Payments</label>
                                    </div>

                                    {/* Reports */}
                                    <div className="col-6 col-sm-4 col-md-3 col-lg-2 d-flex align-items-center">
                                        <input
                                            type="radio"
                                            id="reports"
                                            name="section"
                                            value="Reports"
                                            checked={selectedOption === "Reports"}
                                            onChange={() => handleRadioChange("Reports")}
                                            className="me-2"
                                        />
                                        <label htmlFor="reports" className="mb-0">Reports</label>
                                    </div>
                                </div>
                            </div>

                            {selectedOption === "Dashboard" && (
                                <div className="container-fluid mt-3">
                                    <div className="row g-3">
                                        {/* Customer Complaint Main Panel */}
                                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                            <div className="card border-secondary h-100">
                                                <div
                                                    className="card-header fw-bold"
                                                    style={{ backgroundColor: "#13bfaeff" }}
                                                >
                                                    Dashboard
                                                </div>
                                                <div className="card-body">
                                                    {[
                                                        { label: "Dashboard", value: "Dashboard" },
                                                    ].map((item, index) => (
                                                        <div className="form-check mb-2" key={index} >
                                                            <input
                                                                className="form-check-input"
                                                                style={{ border: "1px solid black" }}
                                                                type="checkbox"
                                                                id={`crm-${item.value}`}
                                                                checked={selectedOperation.includes(item.value)}
                                                                onChange={() => handleCheckboxChange(item.value)}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor={`crm-${item.value}`}
                                                            >
                                                                {item.label}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Customer Queries Section */}
                                        {selectedOperation.includes("Dashboard") && (
                                            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                                <div className="card border-secondary h-100">
                                                    <div className="card-header fw-bold"
                                                        style={{ backgroundColor: "#13bfaeff" }}>
                                                        Dashboard
                                                    </div>
                                                    <div className="card-body">
                                                        {[
                                                            { name: "DashboardAccess", label: "Dashboard" },

                                                        ].map((item, i) => (
                                                            <div className="form-check mb-2" key={i} >
                                                                <input
                                                                    className="form-check-input"
                                                                    style={{ border: "1px solid black" }}
                                                                    type="checkbox"
                                                                    name={item.name}
                                                                    checked={formData[item.name]}
                                                                    onChange={handleCheckboxselected}
                                                                    id={`customer-${i}`}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor={`customer-${i}`}
                                                                >
                                                                    {item.label}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {selectedOption === "Operation" && (
                                <div className="container-fluid mt-3" style={{ whiteSpace: "nowrap" }}>
                                    <div className="row g-3">
                                        {/* Operation Panel */}
                                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                            <div className="card border-secondary h-100">
                                                <div className="card-header fw-bold" style={{
                                                    backgroundColor: "#13bfaeff",
                                                }}>Operation</div>
                                                <div className="card-body">
                                                    {[
                                                        { label: "Docket Booking", value: "Booking" },
                                                        { label: "Smart Booking", value: "Smart Booking" },
                                                        { label: "Outgoing Manifest", value: "Manifest" },
                                                        { label: "Inscan Process Hub", value: "Parcel Scan Data" },
                                                        { label: "Delivery Run Sheet", value: "Run Sheet Entry" },
                                                        { label: "Status Activity Entry", value: "Status Activity Entry" },
                                                        { label: "Delivery Updation", value: "POD Record Update" },
                                                        { label: "Docket Receipt", value: "Docket Print" },
                                                        { label: "Status Upload", value: "Status Upload" },
                                                        { label: "Vendor Bill Entry", value: "Vendor Bill Entry" },

                                                    ].map((item, index) => (
                                                        <div className="form-check mb-2" key={index}>
                                                            <input
                                                                className="form-check-input"
                                                                style={{ border: "1px solid black" }}
                                                                type="checkbox"
                                                                id={`op-${item.value}`}
                                                                checked={selectedOperation.includes(item.value)}
                                                                onChange={() => handleCheckboxChange(item.value)}
                                                            />
                                                            <label className="form-check-label" htmlFor={`op-${item.value}`}>
                                                                {item.label}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Booking */}
                                        {selectedOperation.includes("Booking") && (
                                            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                                <div className="card border-secondary h-100">
                                                    <div className="card-header fw-bold" style={{ backgroundColor: "#13bfaeff" }}>Docket Booking</div>
                                                    <div className="card-body">
                                                        {[
                                                            { name: "DocketBooking", label: "Docket Booking" },
                                                            { name: "PerformaInvoice", label: "Booking Data" },
                                                            { name: "ForwardingInternational", label: "Forwarding" },
                                                            { name: "RateCalculator", label: "Rate Calculator" },
                                                            { name: "CoshTopayBooking", label: "Cash To Pay" },
                                                            { name: "AutoMail", label: "Send Bulk Mail" },
                                                            { name: "BulkImportData", label: "Bulk Booking" },



                                                        ].map((item, i) => (
                                                            <div className="form-check mb-2" key={i}>
                                                                <input
                                                                    className="form-check-input"
                                                                    style={{ border: "1px solid black" }}
                                                                    type="checkbox"
                                                                    name={item.name}
                                                                    checked={formData[item.name]}
                                                                    onChange={handleCheckboxselected}
                                                                    id={`booking-${i}`}
                                                                />
                                                                <label className="form-check-label" htmlFor={`booking-${i}`}>
                                                                    {item.label}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Smart Booking */}
                                        {selectedOperation.includes("Smart Booking") && (
                                            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                                <div className="card border-secondary h-100">
                                                    <div className="card-header fw-bold" style={{ backgroundColor: "#13bfaeff" }}>Smart Booking</div>
                                                    <div className="card-body">
                                                        {[

                                                            { name: "Smartbooking", label: "Smart Booking" },
                                                            { name: "BulkImportFile", label: "Bulk Import File" },
                                                            { name: "BankImport", label: "Bank Import" },
                                                            { name: "TrackingEntry", label: "Tracking Booking" },
                                                            { name: "BulkTrackingUpload", label: "Bulk Upload Tracking" },
                                                            { name: "BulkUploadExcel", label: "Bulk Delivered" },

                                                        ].map((item, i) => (
                                                            <div className="form-check mb-2" key={i}>
                                                                <input
                                                                    className="form-check-input"
                                                                    style={{ border: "1px solid black" }}
                                                                    type="checkbox"
                                                                    name={item.name}
                                                                    checked={formData[item.name]}
                                                                    onChange={handleCheckboxselected}
                                                                    id={`booking-${i}`}
                                                                />
                                                                <label className="form-check-label" htmlFor={`booking-${i}`}>
                                                                    {item.label}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Manifest */}
                                        {selectedOperation.includes("Manifest") && (
                                            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                                <div className="card border-secondary h-100">
                                                    <div className="card-header fw-bold" style={{ backgroundColor: "#13bfaeff" }}>Outgoing Manifest</div>
                                                    <div className="card-body">
                                                        {[
                                                            { name: "PendingManifest", label: "Pending Manifest" },
                                                            { name: "OutgoingManifest", label: "Outgoing Manifest" },
                                                            { name: "ViewManifest", label: "View Manifest" },
                                                            { name: "InternationalManifest", label: "International Manifest" },
                                                            { name: "BuilkimportManifest", label: "Bulk Import Manifest" },
                                                        ].map((item, i) => (
                                                            <div className="form-check mb-2" key={i}>
                                                                <input
                                                                    className="form-check-input"
                                                                    style={{ border: "1px solid black" }}
                                                                    type="checkbox"
                                                                    name={item.name}
                                                                    checked={formData[item.name]}
                                                                    onChange={handleCheckboxselected}
                                                                    id={`booking-${i}`}
                                                                />
                                                                <label className="form-check-label" htmlFor={`booking-${i}`}>
                                                                    {item.label}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Parcel Scan Data */}
                                        {selectedOperation.includes("Parcel Scan Data") && (
                                            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                                <div className="card border-secondary h-100">
                                                    <div className="card-header fw-bold" style={{ backgroundColor: "#13bfaeff" }}>Inscan Process Hub</div>
                                                    <div className="card-body">
                                                        {[
                                                            { name: "PendingScan", label: "Pending Scan" },
                                                            { name: "ScanbyDocketNo", label: "Scan by Docket No" },
                                                            { name: "InscanProcessView", label: "Inscan Process View" },
                                                            { name: "InscanbyDRSNo", label: "Inscan by DRS No" },
                                                        ].map((item, i) => (
                                                            <div className="form-check mb-2" key={i}>
                                                                <input
                                                                    className="form-check-input"
                                                                    style={{ border: "1px solid black" }}
                                                                    type="checkbox"
                                                                    name={item.name}
                                                                    checked={formData[item.name]}
                                                                    onChange={handleCheckboxselected}
                                                                    id={`booking-${i}`}
                                                                />
                                                                <label className="form-check-label" htmlFor={`booking-${i}`}>
                                                                    {item.label}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Run Sheet Entry */}
                                        {selectedOperation.includes("Run Sheet Entry") && (
                                            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                                <div className="card border-secondary h-100">
                                                    <div className="card-header fw-bold" style={{ backgroundColor: "#13bfaeff" }}>Delivery Run Sheet</div>
                                                    <div className="card-body">
                                                        {[
                                                            { name: "DeliveryPending", label: "Delivery Pending" },
                                                            { name: "DeliveryBooking", label: "Delivery Entry" },
                                                            { name: "DrsView", label: "View DRS" },
                                                            { name: "Drsimport", label: "Import DRS" },

                                                        ].map((item, i) => (
                                                            <div className="form-check mb-2" key={i}>
                                                                <input
                                                                    className="form-check-input"
                                                                    style={{ border: "1px solid black" }}
                                                                    type="checkbox"
                                                                    name={item.name}
                                                                    checked={formData[item.name]}
                                                                    onChange={handleCheckboxselected}
                                                                    id={`booking-${i}`}
                                                                />
                                                                <label className="form-check-label" htmlFor={`booking-${i}`}>
                                                                    {item.label}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Status Activity Entry */}
                                        {selectedOperation.includes("Status Activity Entry") && (
                                            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                                <div className="card border-secondary h-100">
                                                    <div className="card-header fw-bold" style={{ backgroundColor: "#13bfaeff" }}>Status Activity Entry</div>
                                                    <div className="card-body">
                                                        {[
                                                            { name: "Statusactivity", label: "Activity Entry" },
                                                            { name: "StatusactivityimportBulk", label: "Activity Import Bulk" },
                                                            { name: "StatusactivityTracking", label: "Activity Tracking" },
                                                        ].map((item, i) => (
                                                            <div className="form-check mb-2" key={i}>
                                                                <input
                                                                    className="form-check-input"
                                                                    style={{ border: "1px solid black" }}
                                                                    type="checkbox"
                                                                    name={item.name}
                                                                    checked={formData[item.name]}
                                                                    onChange={handleCheckboxselected}
                                                                    id={`booking-${i}`}
                                                                />
                                                                <label className="form-check-label" htmlFor={`booking-${i}`}>
                                                                    {item.label}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* POD Record Update */}
                                        {selectedOperation.includes("POD Record Update") && (
                                            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                                <div className="card border-secondary h-100">
                                                    <div className="card-header fw-bold" style={{ backgroundColor: "#13bfaeff" }}>Delivery Updation</div>
                                                    <div className="card-body">
                                                        {[
                                                            { name: "DeliveryEntry", label: "Delivered" },
                                                            { name: "ReturnEntry", label: "Return Booking" },
                                                            { name: "BulkUploadExcel", label: "Bulk Upload (Excel)" },
                                                        ].map((item, i) => (
                                                            <div className="form-check mb-2" key={i}>
                                                                <input
                                                                    className="form-check-input"
                                                                    style={{ border: "1px solid black" }}
                                                                    type="checkbox"
                                                                    name={item.name}
                                                                    checked={formData[item.name]}
                                                                    onChange={handleCheckboxselected}
                                                                    id={`pod-${i}`}
                                                                />
                                                                <label className="form-check-label" htmlFor={`pod-${i}`}>
                                                                    {item.label}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Docket Print */}
                                        {selectedOperation.includes("Docket Print") && (
                                            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                                <div className="card border-secondary h-100">
                                                    <div className="card-header fw-bold" style={{ backgroundColor: "#13bfaeff" }}>Docket Receipt</div>
                                                    <div className="card-body">
                                                        {[
                                                            { name: "DocketPrint1", label: "Delivery Print" },
                                                            { name: "Docketprint2", label: "Delivery Print 2" },
                                                            { name: "Docketprint3", label: "Delivery Print 3" },
                                                            { name: "Docketprint4", label: "Delivery Print 4" },
                                                            { name: "LebelPrintin", label: "Label Printing" },
                                                            { name: "DocketPrint", label: "Label Printing 2" },
                                                            { name: "StickerPrinting", label: "Sticker Printing" },
                                                        ].map((item, i) => (
                                                            <div className="form-check mb-2" key={i}>
                                                                <input
                                                                    className="form-check-input"
                                                                    style={{ border: "1px solid black" }}
                                                                    type="checkbox"
                                                                    name={item.name}
                                                                    checked={formData[item.name]}
                                                                    onChange={handleCheckboxselected}
                                                                    id={`docket-${i}`}
                                                                />
                                                                <label className="form-check-label" htmlFor={`docket-${i}`}>
                                                                    {item.label}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* International Booking */}
                                        {selectedOperation.includes("Status Upload") && (
                                            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                                <div className="card border-secondary h-100">
                                                    <div className="card-header fw-bold" style={{ backgroundColor: "#13bfaeff" }}>Status Upload</div>
                                                    <div className="card-body">
                                                        {[
                                                            { name: "InternationalBooking", label: "Status Upload" },
                                                        ].map((item, i) => (
                                                            <div className="form-check mb-2" key={i}>
                                                                <input
                                                                    className="form-check-input"
                                                                    style={{ border: "1px solid black" }}
                                                                    type="checkbox"
                                                                    name={item.name}
                                                                    checked={formData[item.name]}
                                                                    onChange={handleCheckboxselected}
                                                                    id={`booking-${i}`}
                                                                />
                                                                <label className="form-check-label" htmlFor={`booking-${i}`}>
                                                                    {item.label}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {selectedOperation.includes("Vendor Bill Entry") && (
                                            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                                <div className="card border-secondary h-100">
                                                    <div className="card-header fw-bold" style={{ backgroundColor: "#13bfaeff" }}>Vendor Bill Entry</div>
                                                    <div className="card-body">
                                                        {[
                                                            { name: "VendorBillEntry", label: "Vendor Bill Entry" },
                                                        ].map((item, i) => (
                                                            <div className="form-check mb-2" key={i}>
                                                                <input
                                                                    className="form-check-input"
                                                                    style={{ border: "1px solid black" }}
                                                                    type="checkbox"
                                                                    name={item.name}
                                                                    checked={formData[item.name]}
                                                                    onChange={handleCheckboxselected}
                                                                    id={`booking-${i}`}
                                                                />
                                                                <label className="form-check-label" htmlFor={`booking-${i}`}>
                                                                    {item.label}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}


                            {selectedOption === "CRM" && (
                                <div className="container-fluid mt-3">
                                    <div className="row g-3">
                                        {/* Customer Complaint Main Panel */}
                                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                            <div className="card border-secondary h-100">
                                                <div
                                                    className="card-header fw-bold"
                                                    style={{ backgroundColor: "#13bfaeff" }}
                                                >
                                                    Customer Complaint
                                                </div>
                                                <div className="card-body">
                                                    {[
                                                        { label: "Customer Queries", value: "Customer Queries" },
                                                    ].map((item, index) => (
                                                        <div className="form-check mb-2" key={index}>
                                                            <input
                                                                className="form-check-input"
                                                                style={{ border: "1px solid black" }}
                                                                type="checkbox"
                                                                id={`crm-${item.value}`}
                                                                checked={selectedOperation.includes(item.value)}
                                                                onChange={() => handleCheckboxChange(item.value)}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor={`crm-${item.value}`}
                                                            >
                                                                {item.label}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Customer Queries Section */}
                                        {selectedOperation.includes("Customer Queries") && (
                                            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                                <div className="card border-secondary h-100">
                                                    <div className="card-header fw-bold"
                                                        style={{ backgroundColor: "#13bfaeff" }}>
                                                        Customer Queries
                                                    </div>
                                                    <div className="card-body">
                                                        {[
                                                            { name: "ComplaintRegister", label: "Complaint" },
                                                            { name: "ViewComplaintStatus", label: "View Complaint Status" },
                                                            { name: "ComplaintQuery", label: "Query" },
                                                        ].map((item, i) => (
                                                            <div className="form-check mb-2" key={i}>
                                                                <input
                                                                    className="form-check-input"
                                                                    style={{ border: "1px solid black" }}
                                                                    type="checkbox"
                                                                    name={item.name}
                                                                    checked={formData[item.name]}
                                                                    onChange={handleCheckboxselected}
                                                                    id={`customer-${i}`}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor={`customer-${i}`}
                                                                >
                                                                    {item.label}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}



                            {selectedOption === "Reports" && (
                                <div className="container-fluid mt-3">
                                    <div className="row g-3">
                                        {/* Reports Main Panel */}
                                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                            <div className="card border-secondary h-100">
                                                <div
                                                    className="card-header fw-bold"
                                                    style={{ backgroundColor: "#13bfaeff" }}
                                                >
                                                    Reports
                                                </div>
                                                <div className="card-body">
                                                    {[
                                                        { label: "Booking MIS Report", value: "Status Report" },
                                                        { label: "Booking Detail Report", value: "Statement Wise Report" },
                                                        { label: "Invoice Ledger Report", value: "Sales Register Report" },
                                                    ].map((item, index) => (
                                                        <div className="form-check mb-2" key={index}>
                                                            <input
                                                                className="form-check-input"
                                                                style={{ border: "1px solid black" }}
                                                                type="checkbox"
                                                                id={`report-${item.value}`}
                                                                checked={selectedOperation.includes(item.value)}
                                                                onChange={() => handleCheckboxChange(item.value)}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor={`report-${item.value}`}
                                                            >
                                                                {item.label}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Booking MIS Report */}
                                        {selectedOperation.includes("Status Report") && (
                                            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                                <div className="card border-secondary h-100">
                                                    <div
                                                        className="card-header fw-bold"
                                                        style={{ backgroundColor: "#13bfaeff" }}
                                                    >
                                                        Booking MIS Report
                                                    </div>
                                                    <div className="card-body">
                                                        {[
                                                            { name: "MISReport", label: "MIS Report" },
                                                            { name: "VendorMISReport", label: "Vendor MIS Report" },
                                                            { name: "BookingModeReport", label: "Booking Mode Report" },
                                                        ].map((item, i) => (
                                                            <div className="form-check mb-2" key={i}>
                                                                <input
                                                                    className="form-check-input"
                                                                    style={{ border: "1px solid black" }}
                                                                    type="checkbox"
                                                                    name={item.name}
                                                                    checked={formData[item.name]}
                                                                    onChange={handleCheckboxselected}
                                                                    id={`customer-${i}`}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor={`customer-${i}`}
                                                                >
                                                                    {item.label}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Booking Detail Report */}
                                        {selectedOperation.includes("Statement Wise Report") && (
                                            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                                <div className="card border-secondary h-100">
                                                    <div
                                                        className="card-header fw-bold"
                                                        style={{ backgroundColor: "#13bfaeff" }}
                                                    >
                                                        Booking Detail Report
                                                    </div>
                                                    <div className="card-body">
                                                        {[
                                                            { name: "BookingDetail", label: "Booking Detail" },
                                                            { name: "TotalChargesReport", label: "Total Charges Report" },
                                                            { name: "ModeWiseReport", label: "Mode Wise Report" },
                                                        ].map((item, i) => (
                                                            <div className="form-check mb-2" key={i}>
                                                                <input
                                                                    className="form-check-input"
                                                                    style={{ border: "1px solid black" }}
                                                                    type="checkbox"
                                                                    name={item.name}
                                                                    checked={formData[item.name]}
                                                                    onChange={handleCheckboxselected}
                                                                    id={`detail-${i}`}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor={`detail-${i}`}
                                                                >
                                                                    {item.label}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Invoice Ledger Report */}
                                        {selectedOperation.includes("Sales Register Report") && (
                                            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                                <div className="card border-secondary h-100">
                                                    <div
                                                        className="card-header fw-bold"
                                                        style={{ backgroundColor: "#13bfaeff" }}
                                                    >
                                                        Invoice Ledger Report
                                                    </div>
                                                    <div className="card-body">
                                                        {[
                                                            { name: "InvoiceLedgerReport", label: "Invoice Ledger Report" },
                                                            { name: "ChecklistReport", label: "Checklist Report" },
                                                            { name: "UnbuildReport", label: "Unbuild Report" },
                                                            { name: "BillViewReport", label: "Bill View Report" },
                                                        ].map((item, i) => (
                                                            <div className="form-check mb-2" key={i}>
                                                                <input
                                                                    className="form-check-input"
                                                                    style={{ border: "1px solid black" }}
                                                                    type="checkbox"
                                                                    name={item.name}
                                                                    checked={formData[item.name]}
                                                                    onChange={handleCheckboxselected}
                                                                    id={`customer-${i}`}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor={`customer-${i}`}
                                                                >
                                                                    {item.label}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}


                            {/* Billings Section */}
                            {selectedOption === "Billings" && (
                                <div className="container-fluid mt-3">
                                    <div className="row g-3">
                                        {/* Billings Main Panel */}
                                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                            <div className="card border-secondary h-100">
                                                <div
                                                    className="card-header fw-bold"
                                                    style={{ backgroundColor: "#13bfaeff" }}
                                                >
                                                    Billings
                                                </div>
                                                <div className="card-body">
                                                    <div className="form-check mb-2">
                                                        <input
                                                            className="form-check-input"
                                                            style={{ border: "1px solid black" }}
                                                            type="checkbox"
                                                            id="billing-invoice"
                                                            value="Invoice Generate"
                                                            checked={selectedOperation.includes("Invoice Generate")}
                                                            onChange={() => handleCheckboxChange("Invoice Generate")}
                                                        />
                                                        <label
                                                            className="form-check-label"
                                                            htmlFor="billing-invoice"
                                                        >
                                                            Invoice Generate
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Invoice Generate Section */}
                                        {selectedOperation.includes("Invoice Generate") && (
                                            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                                <div className="card border-secondary h-100">
                                                    <div
                                                        className="card-header fw-bold"
                                                        style={{ backgroundColor: "#13bfaeff" }}
                                                    >
                                                        Invoice Generate
                                                    </div>
                                                    <div className="card-body">
                                                        {[
                                                            { name: "PendingInvoice", label: "Pending Invoice" },
                                                            { name: "GenerateInvoice", label: "Generate Invoice" },
                                                            { name: "ViewInvoice", label: "View Invoice" },
                                                            { name: "InvoiceSummary", label: "Invoice Summary" },
                                                            { name: "Docket_Print", label: "Docket Print" },
                                                            { name: "PerformanceInvoice", label: "Performance Invoice" },
                                                            { name: "ViewPerformanceInvoice", label: "View Performance Invoice" },
                                                        ].map((item, i) => (
                                                            <div className="form-check mb-2" key={i}>
                                                                <input
                                                                    className="form-check-input"
                                                                    style={{ border: "1px solid black" }}
                                                                    type="checkbox"
                                                                    name={item.name}
                                                                    checked={formData[item.name]}
                                                                    onChange={handleCheckboxselected}
                                                                    id={`customer-${i}`}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor={`customer-${i}`}
                                                                >
                                                                    {item.label}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* Payments Section */}
                            {selectedOption === "Payments" && (
                                <div className="container-fluid mt-3">
                                    <div className="row g-3">
                                        {/* Payments Main Panel */}
                                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                            <div className="card border-secondary h-100">
                                                <div
                                                    className="card-header fw-bold"
                                                    style={{ backgroundColor: "#13bfaeff" }}
                                                >
                                                    Payments
                                                </div>
                                                <div className="card-body">
                                                    <div className="form-check mb-2">
                                                        <input
                                                            className="form-check-input"
                                                            style={{ border: "1px solid black" }}
                                                            type="checkbox"
                                                            id="payments-laiser"
                                                            value="Laiser"
                                                            checked={selectedOperation.includes("Laiser")}
                                                            onChange={() => handleCheckboxChange("Laiser")}
                                                        />
                                                        <label
                                                            className="form-check-label"
                                                            htmlFor="payments-laiser"
                                                        >
                                                            Laiser
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Laiser Section */}
                                        {selectedOperation.includes("Laiser") && (
                                            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                                <div className="card border-secondary h-100">
                                                    <div
                                                        className="card-header fw-bold"
                                                        style={{ backgroundColor: "#13bfaeff" }}
                                                    >
                                                        Laiser
                                                    </div>
                                                    <div className="card-body">
                                                        {[
                                                            { label: "Payment Received Entry", name: "PaymentReceivedEntry" },
                                                            { label: "Pay Out Standing", name: "PayOutStanding" },
                                                            { label: "Credit Note", name: "CreditNoteView" },
                                                            { label: "Credit Booking", name: "CreditBooking" },
                                                        ].map((item, i) => (
                                                            <div className="form-check mb-2" key={i}>
                                                                <input
                                                                    className="form-check-input"
                                                                    style={{ border: "1px solid black" }}
                                                                    type="checkbox"
                                                                    name={item.name}
                                                                    checked={formData[item.name]}
                                                                    onChange={handleCheckboxselected}
                                                                    id={`customer-${i}`}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor={`customer-${i}`}
                                                                >
                                                                    {item.label}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}


                            <div style={{ width: "100%" }}>
                                <div className="bottom-buttons">
                                    {
                                        !editMode ? <button className='ok-btn' onClick={handlesave}>Submit</button>
                                            : <button className='ok-btn' type='button' onClick={handleUpdate}>Update</button>
                                    }


                                    <button className='ok-btn' type='button' onClick={ResetAll}>Reset</button>
                                </div>
                            </div>
                            <div className='table-container'>
                                <table className='table table-bordered table-sm'>
                                    <thead className='table-info body-bordered table-sm'>
                                        <tr>
                                            <th scope="col" className='w-60'>Actions</th>
                                            <th scope="col" className='w-60'>ID</th>
                                            <th scope="col" className='w-60'>Branch Name</th>
                                            <th scope="col">User Type</th>
                                            <th scope="col">User Name</th>
                                            <th scope="col">Password</th>
                                            <th scope="col">Employee Name</th>
                                            <th scope="col">Customer Name</th>
                                        </tr>
                                    </thead>
                                    <tbody className='table-body'>
                                        {
                                            getData.filter(data => data?.UserType === "User").map((data, index) => (
                                                < tr key={index} style={{ fontSize: "12px", position: "relative" }}>
                                                    <td className='w-60'>
                                                        <PiDotsThreeOutlineVerticalFill
                                                            style={{ fontSize: "20px", cursor: "pointer" }}
                                                            onClick={() => setOpenRow(openRow === index ? null : index)}
                                                        />
                                                        {openRow === index && (
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    flexDirection: "row",
                                                                    position: "absolute",
                                                                    alignItems: "center",
                                                                    left: "63px",
                                                                    top: "1px",
                                                                    borderRadius: "10px",
                                                                    backgroundColor: "white",
                                                                    zIndex: "999999",
                                                                    height: "24px",
                                                                    width: "70px",
                                                                    padding: "10px",
                                                                }}
                                                            >
                                                                <button className='edit-btn' onClick={() => {
                                                                    setOpenRow(null);
                                                                    setEditMode(true);
                                                                    setFormData({
                                                                        ID: data?.ID,
                                                                        UserName: data?.UserName || "",
                                                                        Employee_Code: data?.Employee_Code || "",
                                                                        Customer_Code: data?.Customer_Code || "",
                                                                        Password: data?.Password || "",
                                                                        City_Code: data?.City_Code || JSON.parse(localStorage.getItem("Login"))?.Branch_Code,
                                                                        UserType: data?.UserType || "User",
                                                                        RateType: data?.RateType ? JSON.parse(data?.RateType) : [],
                                                                        DocketBooking: !!data?.DocketBooking,
                                                                        DocketPrint: !!data?.DocketPrint,
                                                                        CoshTopayBooking: !!data?.CoshTopayBooking,
                                                                        Smartbooking: !!data?.Smartbooking,
                                                                        DashboardAccess: !!data.DashboardAccess,
                                                                        TrackingEntry: !!data.TrackingEntry,
                                                                        BulkTrackingUpload: !!data.BulkTrackingUpload,
                                                                        BulkImportFile: !!data.BulkImportFile,
                                                                        BankImport: !!data.BankImport,
                                                                        AutoMail: !!data?.AutoMail,
                                                                        BulkImportData: !!data?.BulkImportData,
                                                                        VendorBillEntry: !!data?.VendorBillEntry,
                                                                        PerformaInvoice: !!data.PerformaInvoice,
                                                                        ForwardingInternational: !!data.ForwardingInternational,
                                                                        RateCalculator: !!data.RateCalculator,
                                                                        PendingManifest: !!data?.PendingManifest,
                                                                        OutgoingManifest: !!data?.OutgoingManifest,
                                                                        ViewManifest: !!data?.ViewManifest,
                                                                        InternationalManifest: !!data?.InternationalManifest,
                                                                        BuilkimportManifest: !!data?.BuilkimportManifest,
                                                                        PendingScan: !!data?.PendingScan,
                                                                        InscanbyDRSNo: !!data?.InscanbyDRSNo,
                                                                        ScanbyDocketNo: !!data?.ScanbyDocketNo,
                                                                        InscanProcessView: !!data?.InscanProcessView,
                                                                        DeliveryPending: !!data?.DeliveryPending,
                                                                        DeliveryBooking: !!data?.DeliveryBooking,
                                                                        DrsView: !!data?.DrsView,
                                                                        Drsimport: !!data?.Drsimport,
                                                                        Statusactivity: !!data?.Statusactivity,
                                                                        StatusactivityimportBulk: !!data?.StatusactivityimportBulk,
                                                                        StatusactivityTracking: !!data?.StatusactivityTracking,
                                                                        DeliveryEntry: !!data?.DeliveryEntry,
                                                                        ReturnEntry: !!data?.ReturnEntry,
                                                                        BulkUploadExcel: !!data?.BulkUploadExcel,
                                                                        DocketPrint1: !!data?.DocketPrint1,
                                                                        Docketprint2: !!data?.Docketprint2,
                                                                        Docketprint3: !!data?.Docketprint3,
                                                                        Docketprint4: !!data?.Docketprint4,
                                                                        LebelPrintin: !!data?.LebelPrintin,
                                                                        DocketPrint: !!data?.DocketPrint,
                                                                        StickerPrinting: !!data?.StickerPrinting,
                                                                        InternationalBooking: !!data?.InternationalBooking,
                                                                        ComplaintRegister: !!data?.ComplaintRegister,
                                                                        ViewComplaintStatus: !!data?.ViewComplaintStatus,
                                                                        ComplaintQuery: !!data?.ComplaintQuery,
                                                                        PendingInvoice: !!data?.PendingInvoice,
                                                                        GenerateInvoice: !!data?.GenerateInvoice,
                                                                        ViewInvoice: !!data?.ViewInvoice,
                                                                        InvoiceSummary: !!data?.InvoiceSummary,
                                                                        Docket_Print: !!data?.Docket_Print,
                                                                        PerformanceInvoice: !!data?.PerformanceInvoice,
                                                                        ViewPerformanceInvoice: !!data?.ViewPerformanceInvoice,
                                                                        PaymentReceivedEntry: !!data?.PaymentReceivedEntry,
                                                                        PayOutStanding: !!data?.PayOutStanding,
                                                                        CreditBooking: !!data?.CreditBooking,
                                                                        CreditNoteView: !!data?.CreditNoteView,
                                                                        MISReport: !!data?.MISReport,
                                                                        VendorMISReport: !!data?.VendorMISReport,
                                                                        BookingModeReport: !!data?.BookingModeReport,
                                                                        BookingDetail: !!data?.BookingDetail,
                                                                        TotalChargesReport: !!data?.TotalChargesReport,
                                                                        ModeWiseReport: !!data?.ModeWiseReport,
                                                                        InvoiceLedgerReport: !!data?.InvoiceLedgerReport,
                                                                        ChecklistReport: !!data?.ChecklistReport,
                                                                        UnbuildReport: !!data?.UnbuildReport,
                                                                        BillViewReport: !!data?.BillViewReport,
                                                                    });

                                                                    // ✅ Step 2: Derive `operations` based on which flags are true
                                                                    const operations = [];

                                                                    if (
                                                                        data?.DocketBooking === 1 ||
                                                                        data?.CoshTopayBooking === 1 ||
                                                                        data?.AutoMail === 1 ||
                                                                        data?.BulkImportData === 1 ||
                                                                        data?.PerformaInvoice === 1 ||
                                                                        data?.ForwardingInternational === 1 ||
                                                                        data?.RateCalculator === 1
                                                                    ) {
                                                                        operations.push("Booking");
                                                                    }

                                                                    if (
                                                                        data?.Smartbooking === 1 ||
                                                                        data?.TrackingEntry === 1 ||
                                                                        data?.BulkTrackingUpload === 1 ||
                                                                        data?.BulkUploadExcel === 1 ||
                                                                        data?.BankImport === 1 ||
                                                                        data?.BulkImportFile === 1

                                                                    ) {
                                                                        operations.push("Smart Booking");
                                                                    }

                                                                    if (
                                                                        data?.PendingManifest === 1 ||
                                                                        data?.OutgoingManifest === 1 ||
                                                                        data?.ViewManifest === 1 ||
                                                                        data?.InternationalManifest === 1 ||
                                                                        data?.BuilkimportManifest === 1
                                                                    ) {
                                                                        operations.push("Manifest");
                                                                    }

                                                                    if (
                                                                        data?.PendingScan === 1 ||
                                                                        data?.InscanbyDRSNo === 1 ||
                                                                        data?.ScanbyDocketNo === 1 ||
                                                                        data?.InscanProcessView === 1
                                                                    ) {
                                                                        operations.push("Parcel Scan Data");
                                                                    }

                                                                    if (data?.DrsView === 1 ||
                                                                        data?.Drsimport === 1 ||
                                                                        data?.DeliveryPending === 1 ||
                                                                        data?.DeliveryBooking === 1) {
                                                                        operations.push("Run Sheet Entry");
                                                                    }

                                                                    if (
                                                                        data?.Statusactivity === 1 ||
                                                                        data?.StatusactivityimportBulk === 1 ||
                                                                        data?.StatusactivityTracking === 1
                                                                    ) {
                                                                        operations.push("Status Activity Entry");
                                                                    }

                                                                    if (
                                                                        data?.DeliveryEntry === 1 ||
                                                                        data?.ReturnEntry === 1 ||
                                                                        data?.BulkUploadExcel === 1
                                                                    ) {
                                                                        operations.push("POD Record Update");
                                                                    }

                                                                    if (
                                                                        data?.DocketPrint1 === 1 ||
                                                                        data?.Docketprint2 === 1 ||
                                                                        data?.Docketprint3 === 1 ||
                                                                        data?.Docketprint4 === 1 ||
                                                                        data?.LebelPrintin === 1 ||
                                                                        data?.DocketPrint === 1 ||
                                                                        data?.StickerPrinting === 1
                                                                    ) {
                                                                        operations.push("Docket Print");
                                                                    }

                                                                    if (
                                                                        data?.InternationalBooking === 1
                                                                    ) {
                                                                        operations.push("Status Upload");
                                                                    }

                                                                    if (
                                                                        data?.VendorBillEntry === 1
                                                                    ) {
                                                                        operations.push("Vendor Bill Entry");
                                                                    }

                                                                    if (
                                                                        data?.ComplaintRegister === 1 ||
                                                                        data?.ViewComplaintStatus === 1 ||
                                                                        data?.ComplaintQuery === 1
                                                                    ) {
                                                                        operations.push("Customer Queries");
                                                                    }

                                                                    if (
                                                                        data?.PendingInvoice === 1 ||
                                                                        data?.GenerateInvoice === 1 ||
                                                                        data?.ViewInvoice === 1 ||
                                                                        data?.InvoiceSummary === 1 ||
                                                                        data?.Docket_Print === 1 ||
                                                                        data?.PerformanceInvoice === 1 ||
                                                                        data?.ViewPerformanceInvoice === 1
                                                                    ) {
                                                                        operations.push("Invoice Generate");
                                                                    }

                                                                    if (data?.PaymentReceivedEntry === 1 ||
                                                                        data?.PayOutStanding === 1 ||
                                                                        data?.CreditBooking === 1 ||
                                                                        data?.CreditNoteView === 1) {
                                                                        operations.push("Laiser");
                                                                    }

                                                                    if (data?.MISReport === 1 ||
                                                                        data?.VendorMISReport === 1 ||
                                                                        data?.BookingModeReport === 1
                                                                    ) {
                                                                        operations.push("Status Report");
                                                                    }

                                                                    if (
                                                                        data?.TotalChargesReport === 1 ||
                                                                        data?.ModeWiseReport === 1 ||
                                                                        data?.BookingDetail === 1
                                                                    ) {
                                                                        operations.push("Statement Wise Report");
                                                                    }

                                                                    if (data?.InvoiceLedgerReport === 1 ||
                                                                        data?.ChecklistReport === 1 ||
                                                                        data?.UnbuildReport === 1 ||
                                                                        data?.BillViewReport === 1) {
                                                                        operations.push("Sales Register Report");
                                                                    }

                                                                    console.log("✅ Operations from API:", operations);
                                                                    setSelectedOperation(operations);
                                                                    setSelectedOption("Dashboard");

                                                                }
                                                                }>
                                                                    <i className='bi bi-pen'></i>
                                                                </button>
                                                                <button onClick={() => {
                                                                    setOpenRow(null);
                                                                    handleDelete(data?.ID);
                                                                }} className='edit-btn'><i className='bi bi-trash'></i></button>
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td className="w-60">{data?.ID}</td>
                                                    <td className="w-60">{data?.City_Name}</td>
                                                    <td>{data?.UserType}</td>
                                                    <td>{data?.UserName}</td>
                                                    <td>{data?.Password}</td>
                                                    <td>{data?.Employee_Name}</td>
                                                    <td>{data?.Customer_Name}</td>

                                                </tr>))}
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </form>
                </div >
                <Footer />
            </div >

        </>
    )
}

export default UserAdmin;
